export default function RemoveIcon({size = 24}) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6.20703 13C5.9237 13 5.6862 12.9042 5.49453 12.7125C5.30286 12.5208 5.20703 12.2833 5.20703 12C5.20703 11.7167 5.30286 11.4792 5.49453 11.2875C5.6862 11.0958 5.9237 11 6.20703 11H18.207C18.4904 11 18.7279 11.0958 18.9195 11.2875C19.1112 11.4792 19.207 11.7167 19.207 12C19.207 12.2833 19.1112 12.5208 18.9195 12.7125C18.7279 12.9042 18.4904 13 18.207 13H6.20703Z"
      fill="#1C1B1F"/>
  </svg>
}